import { format } from 'date-fns';
import i18next from 'i18next';
import { VehicleStateEnum } from 'src/api';
import type * as MT from '../motornet/types';

interface ExportOptions {
	canViewPromoNote: boolean;
}

const soldAt = (vehicle: any) => {
	if (vehicle.stato_corrente?.type !== VehicleStateEnum.VENDUTO) return '';

	try {
		return format(
			new Date(vehicle.stato_corrente?.data_inizio || ''),
			'yyyy-MM-dd'
		);
	} catch (error) {
		console.warn(error);
		return '';
	}
};

export const buildVehicleExportData = (
	vehicles: MT.PlatformVehicleListItem[],
	{ canViewPromoNote }: ExportOptions
): (string | number)[][] => {
	const headers = [
		i18next.t('state'),
		i18next.t('brand'),
		i18next.t('availability'),
		i18next.t('model'),
		i18next.t('year'),
		i18next.t('car_setup'),
		i18next.t('commerial_order'),
		i18next.t('builder_code'),
		i18next.t('vehicle_frame'),
		i18next.t('vehicle_plate'),
		i18next.t('list_price'),
		i18next.t('dealer'),
		i18next.t('estimated_delivery'),
		i18next.t('min_rental_fee'),
		i18next.t('external_color_code'),
		i18next.t('internal_color_code'),
		i18next.t('city'),
		i18next.t('vehicle_registration_date'),
		i18next.t('fuel_type'),
		i18next.t('vehicle_gear'),
		i18next.t('vehicle_drive_system'),
		i18next.t('vehicle_body'),
		i18next.t('user'),
		i18next.t('promo'),
		...(canViewPromoNote ? [i18next.t('promo_note')] : []),
		i18next.t('total_optionals_no_iva'),
		i18next.t('opportunity_closing_date'),
	];

	const rows = vehicles.filter(Boolean).map((vehicle: any) => {
		const optionalsSum =
			vehicle.optionals?.reduce(
				(sum: number, opt: any) => sum + (opt.valore || 0),
				0
			) ?? 0;

		return [
			vehicle.stato_corrente?.type ?? '',
			vehicle.marca ?? '',
			vehicle.stato_disp ?? '',
			vehicle.modello ?? '',
			vehicle.model_year ?? '',
			vehicle.allestimento ?? '',
			vehicle.nr_ordine ?? '',
			vehicle.manufacture_code || vehicle.codice_costruttore || '',
			vehicle.telaio ?? '',
			vehicle.targa ?? '',
			vehicle.prezzo_listino ?? '',
			vehicle.dealer ?? '',
			vehicle.data_disp ?? '',
			vehicle.offerta_minima?.valore
				? `€${vehicle.offerta_minima.valore} (${vehicle.offerta_minima.noleggiatore})`
				: '',
			vehicle.colore_esterno ?? '',
			vehicle.colore_interno ?? '',
			vehicle.city ?? '',
			vehicle.data_immatricolazione ?? '',
			vehicle.alimentazione ?? '',
			vehicle.cambio ?? '',
			vehicle.trazione ?? '',
			vehicle.carrozzeria ?? '',
			vehicle.stato_corrente?.utente ?? '',
			vehicle.promo ? 'X' : '',
			...(canViewPromoNote ? [vehicle.promo_note ?? ''] : []),
			optionalsSum ? parseFloat((optionalsSum / 1.22).toFixed(2)) : '',
			soldAt(vehicle),
		].map((value) =>
			typeof value === 'string' ? value.replace(/\n/g, ' ') : value
		);
	});

	return [headers, ...rows];
};
